import _defineProperty from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from './../../../external/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Chip, MenuItem, Checkbox, ListItemText, TextField } from '@mui/material';
import { useField } from 'formik';
import startCase from 'lodash/startCase';
import '@apollo/client';
import { findSelectedOptions, removeEmptyPlaceholderOption } from '../../../utils/inputUtils.js';
import '../../../utils/popupUtils.js';
import { makeStyles } from '../../../utils/stylesUtils.js';
import { selectOptionsToOptionNodes } from '../../../utils/uiUtils.js';
/** A Material UI Text Field with Formik bindings */

var FormikTextField = function FormikTextField(_a) {
  var name = _a.name,
      helperText = _a.helperText,
      SelectProps = _a.SelectProps,
      className = _a.className,
      textFieldProps = __rest(_a, ["name", "helperText", "SelectProps", "className"]);

  var _useStyles = useStyles(),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var _useField = useField(name),
      _useField2 = _slicedToArray(_useField, 2),
      _useField2$ = _useField2[0],
      value = _useField2$.value,
      onChange = _useField2$.onChange,
      _useField2$2 = _useField2[1],
      error = _useField2$2.error,
      touched = _useField2$2.touched;

  var showError = touched && !!error;
  var selectProps = {
    SelectProps: {
      native: true
    }
  };

  if (textFieldProps.select) {
    if (!SelectProps) console.error("`SelectProps` must be passed if using `select` input");else {
      var multiple = SelectProps.multiple;
      selectProps = !multiple ? {
        SelectProps: {
          multiple: multiple,
          native: true
        },
        children: selectOptionsToOptionNodes(SelectProps.options)
      } : {
        SelectProps: {
          multiple: multiple,
          renderValue: function renderValue(selected) {
            return jsx("div", Object.assign({
              className: classes.chips
            }, {
              children: findSelectedOptions(selected, SelectProps.options, "value").map(function (opt) {
                return jsx(Chip, {
                  label: opt.label,
                  className: classes.chip
                }, opt.value);
              })
            }));
          }
        },
        children: removeEmptyPlaceholderOption(SelectProps.options).map(function (opt) {
          return jsxs(MenuItem, Object.assign({
            value: opt.value
          }, {
            children: [jsx(Checkbox, {
              checked: value.indexOf(opt.value) > -1
            }), jsx(ListItemText, {
              primary: opt.label
            })]
          }), opt.value);
        }),
        className: cx(className, classes.input, _defineProperty({}, classes.multipleSelected, value.length))
      };
    }
  }

  return jsx(TextField, Object.assign({
    label: startCase(name),
    variant: "outlined",
    className: className
  }, selectProps, textFieldProps, {
    name: name,
    value: value !== null && value !== void 0 ? value : "",
    onChange: onChange,
    error: showError,
    helperText: showError ? error : helperText
  }));
};

var useStyles = makeStyles()({
  input: {
    "& .MuiSelect-select": {
      "&:focus": {
        backgroundColor: "transparent"
      }
    }
  },
  multipleSelected: {
    "& .MuiSelect-select": {
      paddingTop: 10,
      paddingBottom: 10
    }
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: 2
  }
});
export { FormikTextField };